module.exports = __webpack_public_path__ + "img/mixerTruk-green.cabb1b22.svg";